// Global Stubs and Initializations
window.routes = window.routes || {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_update_url: '/cart/update',
    cart_url: '/cart',
    predictive_search_url: '/search/suggest'
};

window.CartPerformance = window.CartPerformance || {
    createStartingMarker: () => Date.now(),
    measureFromMarker: () => { },
    measure: (name, callback) => callback(),
    measureFromEvent: () => { }
};

window.Shopify = window.Shopify || {};
window.Shopify.formatMoney = window.Shopify.formatMoney || ((cents) => (cents / 100).toFixed(2));

function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

class SectionId {
    static #separator = '__';

    static parseId(qualifiedSectionId) {
        return qualifiedSectionId.split(SectionId.#separator)[0];
    }

    static parseSectionName(qualifiedSectionId) {
        return qualifiedSectionId.split(SectionId.#separator)[1];
    }

    static getIdForSection(sectionId, sectionName) {
        return `${sectionId}${SectionId.#separator}${sectionName}`;
    }
}

class HTMLUpdateUtility {
    static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
        preProcessCallbacks?.forEach((callback) => callback(newContent));

        const newNodeWrapper = document.createElement('div');
        HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
        const newNode = newNodeWrapper.firstChild;

        const uniqueKey = Date.now();
        oldNode.querySelectorAll('[id], [form]').forEach((element) => {
            element.id && (element.id = `${element.id}-${uniqueKey}`);
            element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
        });

        oldNode.parentNode.insertBefore(newNode, oldNode);
        oldNode.style.display = 'none';

        postProcessCallbacks?.forEach((callback) => callback(newNode));

        setTimeout(() => oldNode.remove(), 500);
    }

    static setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
            const newScriptTag = document.createElement('script');
            Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
            });
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
    }
}

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    window.trapFocusHandlers = window.trapFocusHandlers || {};
    window.trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', window.trapFocusHandlers.keydown);
    };

    window.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', window.trapFocusHandlers.keydown);
    };

    window.trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return;
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', window.trapFocusHandlers.focusout);
    document.addEventListener('focusin', window.trapFocusHandlers.focusin);

    elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
    if (window.trapFocusHandlers) {
        document.removeEventListener('focusin', window.trapFocusHandlers.focusin);
        document.removeEventListener('focusout', window.trapFocusHandlers.focusout);
        document.removeEventListener('keydown', window.trapFocusHandlers.keydown);
    }
    if (elementToFocus) elementToFocus.focus();
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
}

// Zoom Dialog Functionality
window.openZoomDialog = function (imageSrc, imageAlt) {
    let zoomDialog = document.getElementById('tz-zoom-dialog');
    if (!zoomDialog) {
        zoomDialog = document.createElement('div');
        zoomDialog.id = 'tz-zoom-dialog';
        zoomDialog.className = 'tz-zoom-dialog-overlay';
        zoomDialog.innerHTML = `
      <div class="tz-zoom-dialog">
        <button class="tz-zoom-dialog-close" aria-label="Close zoom">
          <span class="material-icons-outlined">close</span>
        </button>
        <div class="tz-zoom-dialog-content">
          <img src="" alt="" class="tz-zoom-dialog-image">
        </div>
      </div>
    `;
        document.body.appendChild(zoomDialog);

        zoomDialog.addEventListener('click', (e) => {
            if (e.target === zoomDialog || e.target.closest('.tz-zoom-dialog-close')) {
                closeZoomDialog();
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && zoomDialog.style.display === 'flex') {
                closeZoomDialog();
            }
        });
    }

    const dialogImage = zoomDialog.querySelector('.tz-zoom-dialog-image');
    if (dialogImage) {
        dialogImage.src = imageSrc;
        dialogImage.alt = imageAlt || '';
    }

    zoomDialog.style.display = 'flex';
    document.body.style.overflow = 'hidden';
};

function closeZoomDialog() {
    const zoomDialog = document.getElementById('tz-zoom-dialog');
    if (zoomDialog) {
        zoomDialog.style.display = 'none';
        document.body.style.overflow = '';
    }
}

// Global initialization for product sections
function initProductSection(productInfo) {
    if (!productInfo || productInfo.dataset.tzInitialized === 'true') return;
    productInfo.dataset.tzInitialized = 'true';

    // 1. Thumbnails & Main Image Interaction
    const thumbnails = productInfo.querySelectorAll('.tz-product-thumbnail');
    const mainImage = productInfo.querySelector('[id^="tz-product-main-img"]');

    if (thumbnails.length > 0 && mainImage) {
        thumbnails.forEach((thumb) => {
            thumb.addEventListener('click', (e) => {
                e.preventDefault();
                const thumbnailImg = thumb.querySelector('img');
                if (thumbnailImg && mainImage) {
                    const thumbnailSrc = thumbnailImg.src;
                    const fullSizeSrc = thumbnailSrc.replace(/width=\d+/, 'width=1200');
                    mainImage.src = fullSizeSrc;
                    mainImage.alt = thumbnailImg.alt;
                    thumbnails.forEach((t) => t.classList.remove('is-active'));
                    thumb.classList.add('is-active');
                }
            });
        });
    }

    // 2. Variant Button Clicks (Color Swatches & Size Buttons)
    productInfo.addEventListener('click', (e) => {
        const variantButton = e.target.closest('.tz-color-swatch, .tz-size-button');
        if (!variantButton || variantButton.disabled || variantButton.classList.contains('is-disabled')) return;

        e.preventDefault();
        e.stopPropagation();

        const value = variantButton.dataset.value;
        const index = variantButton.dataset.optionIndex;

        // Update visual active state
        const group = variantButton.closest('.tz-color-swatches, .tz-size-grid');
        if (group) {
            group.querySelectorAll('.tz-color-swatch, .tz-size-button').forEach(btn => btn.classList.remove('is-active'));
            variantButton.classList.add('is-active');
        }

        // Collect all selected values
        const selectedOptionValues = Array.from(productInfo.querySelectorAll('.tz-color-swatch.is-active, .tz-size-button.is-active'))
            .map(btn => btn.dataset.value);

        // Publish event for product-info.js to handle (AJAX update)
        if (window.publish && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
                data: {
                    event: e,
                    target: variantButton,
                    selectedOptionValues: selectedOptionValues
                }
            });
        }
    });

    // 3. Quantity Selector Interaction
    const quantityInput = productInfo.querySelector('.tz-quantity-field');
    const quantityPlus = productInfo.querySelector('.tz-quantity-plus');
    const quantityMinus = productInfo.querySelector('.tz-quantity-minus');

    if (quantityInput && quantityPlus && quantityMinus) {
        quantityPlus.addEventListener('click', (e) => {
            e.preventDefault();
            quantityInput.value = parseInt(quantityInput.value) + 1;
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        });

        quantityMinus.addEventListener('click', (e) => {
            e.preventDefault();
            const val = parseInt(quantityInput.value);
            if (val > 1) {
                quantityInput.value = val - 1;
                quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('product-info').forEach(initProductSection);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    if (node.tagName === 'PRODUCT-INFO') initProductSection(node);
                    node.querySelectorAll?.('product-info').forEach(initProductSection);
                }
            });
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });
});
